import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { showToast } from 'hfs-common-ui';
import { HfsSettingsActionEnum } from 'fleet-data-model';
import { AppState } from '~/reducers';
import {
  MowerSettingsOperationPayload,
  setResultNotificationSent,
} from '~/domain/assets/store/hfs-operations/reducer';
import type { Operation } from '~/domain/assets/models/Operation';
import { InternationalizationNameSpace } from '~/constants/internationalization-namespace';

interface Params {
  update: MowerSettingsOperationPayload;
}

export const mapLangKeys = (operation: Operation) => {
  if (operation.hfsActionId === HfsSettingsActionEnum.MOWER_CUTTING_HEIGHT) {
    return {
      title: 'cutting_height_updated_feedback_title',
      description: 'cutting_height_updated_feedback_content',
    };
  }
  if (operation.hfsActionId === HfsSettingsActionEnum.MOWER_SCHEDULE) {
    return {
      title: 'schedule_updated_feedback_title',
      description: 'schedule_updated_feedback_content',
    };
  }
};

const MowerSettingsUpdateSuccessNotification = ({ update }: Params) => {
  const { t } = useTranslation([InternationalizationNameSpace.RoboticMowerDetails]);
  const dispatch = useDispatch();
  const operations = useSelector((state: AppState) => state.assetHfsOperations.operations);
  const operation = operations.find((op) => op.operationId === update.operationId);

  useEffect(() => {
    if (operation?.operationId !== undefined) {
      const langKeys = mapLangKeys(operation);
      if (langKeys !== undefined) {
        showToast({
          message: (
            <Trans
              ns={InternationalizationNameSpace.RoboticMowerDetails}
              i18nKey={langKeys.description}
            />
          ) as unknown as string,
          title: t(langKeys.title),
          icon: 'action.check',
          iconColor: 'green500',
          position: 'top-right',
          autoClose: 5000,
        });
        dispatch(setResultNotificationSent(operation.operationId));
      }
    }
  }, [dispatch, operation, t]);

  return undefined;
};

export { MowerSettingsUpdateSuccessNotification };
